import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useApiResource } from '../hooks/useApiResource';
import { DetailPageLayout, DetailPageState } from '../components/DetailPageLayout';
import { getPartnerCategoryLabel } from '../lib/contentLabels';

export default function PartnerDetail() {
  const { slug } = useParams();
  const { i18n } = useTranslation();
  const { data: partner, loading, error } = useApiResource(`/partners/${slug}`, { lang: i18n.language });

  const getLocalizedField = (item, field) => {
    if (i18n.language === 'en' && item[`${field}_en`]) {
      return item[`${field}_en`];
    }
    return item[field];
  };

  if (loading) {
    return <DetailPageState compact>Loading...</DetailPageState>;
  }

  if (!partner) {
    return <DetailPageState compact>{error ? 'Failed to load partner.' : 'Partner not found.'}</DetailPageState>;
  }

  const labels = i18n.language === 'en'
    ? { back: 'Back to partners', categories: 'Categories', country: 'Country' }
    : { back: 'Назад к партнерам', categories: 'Категории', country: 'Страна' };

  return (
    <DetailPageLayout compact backTo="/partners" backLabel={labels.back}>
        <div className="glass rounded-3xl p-8 md:p-10 space-y-6">
          <div className="w-28 h-28 rounded-3xl bg-white/5 overflow-hidden">
            <img src={partner.logo_url} alt={getLocalizedField(partner, 'name')} className="w-full h-full object-cover" />
          </div>
          <div className="space-y-3">
            <h1 className="detail-page-title">
              {getLocalizedField(partner, 'name')}
            </h1>
            <p className="detail-page-body whitespace-pre-line">
              {getLocalizedField(partner, 'description')}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="glass rounded-2xl p-4">
              <div className="text-xs uppercase tracking-widest text-[#E11D2E] mb-2">{labels.country}</div>
              <div className="text-white">{partner.country}</div>
            </div>
            <div className="glass rounded-2xl p-4">
              <div className="text-xs uppercase tracking-widest text-[#E11D2E] mb-2">{labels.categories}</div>
                <div className="flex flex-wrap gap-2">
                  {partner.categories.map((cat) => (
                    <span key={cat} className="text-xs bg-white/5 text-white/70 px-3 py-1 rounded-full">
                    {getPartnerCategoryLabel(cat, i18n.language)}
                    </span>
                  ))}
                </div>
            </div>
          </div>
        </div>
    </DetailPageLayout>
  );
}
